// extracted by mini-css-extract-plugin
export var cardTitle = "_hx-1";
export var commentBubble = "_hx-e";
export var commentForm = "_hx-a";
export var commentInput = "_hx-b";
export var commentLabel = "_hx-d";
export var commentPrompt = "_hx-9";
export var csatCard = "_hx-0";
export var feedbackSection = "_hx-7";
export var starDisabled = "_hx-6";
export var starEmpty = "_hx-5";
export var starFilled = "_hx-4";
export var starWrapper = "_hx-3";
export var starsContainer = "_hx-2";
export var submittedComment = "_hx-c";
export var thankYouText = "_hx-8";